<template>
  <div class="block" :class="{needback, big, inmargin: !big }">
    <div class="top">
      <div class="left">
        <div class="row ch">
          <div v-if="done" class="done-icon">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="22" height="22" rx="11" fill="var(--good)" />
              <path
                d="M7 11.2L9.54548 14L15 8"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <p
            v-if="title"
            class="label"
            :class="{ must, head: big }"
            :style="{ margin: desc ? '0 0 6px' : '0 0 10px' }"
          >
            {{ title }}
          </p>
        </div>

        <p v-if="desc" class="desc" style="margin: 0 0 8px">
          {{ desc }}
        </p>
      </div>

      <div class="right">
        <slot name="right"></slot>
      </div>
    </div>

    <div v-if="hr" class="line"></div>

    <slot></slot>

    <p v-if="error" class="error" style="margin: 8px 0 8px">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BlockWithRight',

  props: {
    must: Boolean,
    big: Boolean,
    hr: Boolean,
    done: Boolean,
    needback: Boolean,
    title: String,
    desc: String,
    error: String,
  },
}
</script>

<style scoped>
.block {
  position: relative;

  /* hug content */
  display: inline-flex;
  flex-direction: column;
  width: auto;
  max-width: max-content;
  align-items: flex-start;
}

.top {
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  width: auto;
  max-width: max-content;
  gap: 12px;
}

.left {
  display: inline-flex;
  flex-direction: column;
  width: auto;
  max-width: max-content;
  align-items: flex-start;
}

.right {
  display: inline-flex;
  flex-direction: column;
  width: auto;
  max-width: max-content;
  align-items: flex-start;
  flex-shrink: 0;
}

.row {
  display: flex;
  align-items: center;
  width: auto;
}

.ch {
  width: auto;
}

.done-icon {
  margin-top: -10px;
  margin-right: 10px;
  display: flex;
  flex-shrink: 0;
}

.label {
  font-size: 15px;
  font-weight: 600;
  color: var(--g7);
  line-height: 14px;
}

.must::after {
  content: '*';
  color: var(--primary);
  margin-left: 2px;
}

.desc {
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  color: var(--g2);
  width: auto;
  max-width: 200px;
}

.desc:hover {
  color: var(--g6);
}

.big {
  margin: 12px 0 40px;
}

.inmargin {
  margin: 12px 0 12px;
}

.head {
  font-size: 18px;
  font-weight: 600;
  color: var(--g7);
  line-height: 100%;
}

.line {
  width: 100%;
  border-bottom: 0.5px solid var(--g05);
  margin-bottom: 12px;
}

.error {
  font-size: 14px;
  font-weight: 500;
  line-height: 15px;
  color: rgb(215, 39, 60);
}

.needback{
  background-color: var(--g03);
  padding: 10px 15px;
  border-radius: 10px;
}
.needback:hover{
  background-color: var(--g05);  
}
</style>